import get from 'lodash/get';
import qs from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import LoginPage from '../components/general/Login';

const Login = (props) => {
  const { disablePasswordChangeScreen, showRegistrationScreen, location, loggedIn, token } = props;
  const { from } = location.state || { from: { pathname: '/' } };
  const { search } = location;

  const { returnUrlToAdmin = '' } = qs.parse(search);
  const isAdminUrl = returnUrlToAdmin.includes('.aspx');
  const shouldRedirectToAdminApp =
    loggedIn && disablePasswordChangeScreen && returnUrlToAdmin && token && isAdminUrl;

  //if an app url includes 'returnUrlToAdmin' query parameter and user is successfully logged in
  //then we have to redirect user directly to Admin app and append token to this url
  if (shouldRedirectToAdminApp) {
    const adminUrl = returnUrlToAdmin.includes('?')
      ? `${returnUrlToAdmin}&Token=${token}`
      : `${returnUrlToAdmin}?Token=${token}`;

    window.location.replace(adminUrl);
    return;
  }

  return loggedIn && disablePasswordChangeScreen ? (
    <Redirect to={from} {...props} />
  ) : (
    <LoginPage
      disablePasswordChangeScreen={disablePasswordChangeScreen}
      showRegistrationScreen={showRegistrationScreen}
    />
  );
};

const mapStateToProps = (state) => {
  const auth = get(state, 'auth', {});
  const { logged_in: loggedIn, requirePasswordChange, requireRegistration, token } = auth;

  return {
    loggedIn,
    disablePasswordChangeScreen: !requirePasswordChange,
    showRegistrationScreen: requireRegistration,
    token,
  };
};

export default connect(mapStateToProps, null)(Login);
